var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 58.6666H40C53.3333 58.6666 58.6667 53.3333 58.6667 39.9999V23.9999C58.6667 10.6666 53.3333 5.33325 40 5.33325H24C10.6667 5.33325 5.33334 10.6666 5.33334 23.9999V39.9999C5.33334 53.3333 10.6667 58.6666 24 58.6666Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5467 38.6401L25.8933 30.4001C26.8 29.2268 28.48 29.0134 29.6533 29.9201L34.5333 33.7601C35.7067 34.6668 37.3867 34.4534 38.2933 33.3068L44.4533 25.3601",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.5694e88c051000a91ea399b73d3cca92.svg";
export { ForwardRef as ReactComponent };